import styles from "./AuthContainer.module.scss"
import { AuthContainerProps } from "./AuthContainer.types"

export default function AuthContainer(props: AuthContainerProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
